import { useTranslation } from "react-i18next";
const useNavigationTitle = () => {
  const { t } = useTranslation("navigation");
  return ({ description, titleKey }) => titleKey ? t(titleKey) : description;
};
export default useNavigationTitle;
